import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import Model from './components/Model';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Footer from './components/Footer';
import ExperienceLoader from './components/ExperienceLoader';
import { LoadingProvider } from './context/LoadingContext';

import * as Sentry from '@sentry/react';

const App = () => {
  return (
    <LoadingProvider>
      <main className="bg-black relative">
        <ExperienceLoader />
        <Navbar />
        <Hero />
        <Highlights />
        <Model />
        <Features />
        <HowItWorks />
        <Footer />
      </main>
    </LoadingProvider>
  )
}

export default Sentry.withProfiler(App);
